module.exports = __webpack_public_path__ + "img/UBM.4db5c94f.svg";